import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { useLocation } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [errors, setErrors] = useState({});
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const location = useLocation();
  const { sub } = location.state || {};

  const createOrderNumber = () => {
    const digits = new Uint8Array(27);
    window.crypto.getRandomValues(digits);

    return Array.from(digits, (value, index) => {
      const digit = value % 10;
      return index === 0 && digit === 0 ? 1 : digit;
    }).join("");
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const newErrors = {};
    const email = contact.trim();

    if (!email) newErrors.contact = "Enter an email address";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.contact = "Enter a valid email address";
    }
    if (!countryCode) newErrors.countryCode = "Select a country";
    if (!postalCode) newErrors.postalCode = "Enter a ZIP / postal code";
    if (!firstName) newErrors.firstName = "Enter a first name";
    if (!lastName) newErrors.lastName = "Enter a last name";
    if (!address) newErrors.address = "Enter an address";
    if (!city) newErrors.city = "Enter a city";

    const firstCartItem = cartItems.find((item) => getProductById(item.id));
    const firstProduct = firstCartItem
      ? getProductById(firstCartItem.id)
      : null;
    const total = calculateTotal();

    if (!firstProduct || total <= 0) {
      newErrors.order = "Your cart is empty. Add an item before paying.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const siteUrl = window.location.origin;
    const paymentUrl = new URL("/create_payment.php", siteUrl);
    paymentUrl.search = new URLSearchParams({
      orderNo: createOrderNumber(),
      amount: total.toFixed(2),
      currency: "GBP",
      email,
      success_url: new URL("/success_url", siteUrl).toString(),
      cancel_url: new URL("/cancel_url", siteUrl).toString(),
      title: firstProduct.name,
    }).toString();

    window.location.assign(paymentUrl.toString());
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;

      const price = parseFloat(product.price.replace(/,/g, ""));
      return total + price * item.quantity;
    }, 0);
  };

  return (
    <body
      id="ban-do-we-exist-to-help-you-be-your-best"
      className="template-index theme-animate-hover"
    >
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <form onSubmit={handlePlaceOrder} noValidate>
                <div className="form-group">
                  <label>Contact</label>
                  <input
                    type="email"
                    id="contact"
                    name="contact"
                    value={contact}
                    placeholder="Email address"
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {errors.contact && <p className="error">{errors.contact}</p>}
                </div>

                <div className="form-group">
                  <label>Billing information</label>
                  <ReactFlagsSelect
                    selected={countryCode}
                    onSelect={(code) => setCountryCode(code)}
                    className="check-select"
                  />
                  {errors.countryCode && (
                    <p className="error">{errors.countryCode}</p>
                  )}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      placeholder="First name *"
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                    {errors.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      placeholder="Last name *"
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                    {errors.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="company-name"
                    name="company-name"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Company name (optional)"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    placeholder="Address"
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address1"
                    name="address1"
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    placeholder="Apartment, suite, etc. (optional)"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={city}
                      placeholder="city"
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="postalCode"
                      name="postalCode"
                      value={postalCode}
                      placeholder="Postal code"
                      onChange={(e) => setPostalCode(e.target.value)}
                      required
                    />
                    {errors.postalCode && (
                      <p className="error">{errors.postalCode}</p>
                    )}
                  </div>
                </div>
                <button type="submit" className="check-checkout-button">
                  Pay Now
                </button>
                {errors.order && (
                  <p className="error order-error">{errors.order}</p>
                )}
              </form>
            </div>
          </div>

          {!sub && (
            <div className="right">
              <div className="check-order-summary">
                <div className="check-order-details">
                  {cartItems.map((item, index) => {
                    const product = getProductById(item.id);
                    if (!product || !product.images) return null;
                    return (
                      <div key={index} className="check-cart-item">
                        <img src={product.images[0]} alt="Product" />
                        <div className="pro--qty">
                          <div className="qty-inner">{item.quantity}</div>
                        </div>
                        <div className="check-item-details">
                          <h3>
                            {product.name}
                            {item.size && (
                              <>
                                <br />
                                Size: {item.size}
                              </>
                            )}
                            {item.color && (
                              <>
                                <br />
                                Color: {item.color}
                              </>
                            )}
                          </h3>
                        </div>
                        <p className="cal-single">£{product.price} </p>
                      </div>
                    );
                  })}

                  <div className="check-summary-details">
                    <div className="gridTotal">
                      <table className="summary-details22">
                        <tbody className="sumTbody22">
                          <tr className="sumTr22">
                            <th
                              className="subtotalTh22"
                              style={{ fontSize: "24px" }}
                            >
                              Total
                            </th>
                            <th className="subtotalTxt22">
                              £{calculateTotal().toFixed(2)}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </body>
  );
};

export default CheckOut;
